module.exports = __webpack_public_path__ + "img/empty-step-one.0d95505d.svg";